// Importa tus imágenes aquí - asegúrate de ajustar las rutas según tu estructura de proyecto
import Desarrollo from "../assets/derechos.png"
import Financiera from "../assets/financieras.png"
import Tributaria from "../assets/tributaria.png"


export const servicesData = [
  {
    id: 1,
    title: "Proyectos en Desarrollo",
    description:
      "Asesoría preventiva y especializada en derechos del consumidor financiero. Optimiza tus recursos con nuestra ayuda.",
    image: Desarrollo,
    alt: "Proyectos en Desarrollo",
  },
  {
    id: 2,
    title: "Consultorías Financieras",
    description:
      "Asesoramiento en estructuración de portafolios, gestión de activos y más, tanto para PYMES como personas naturales.",
    image: Financiera,
    alt: "Consultorías Financieras",
  },
  {
    id: 3,
    title: "Asesoría Tributaria",
    description:
      "Soluciones en impuestos y retenciones, planeación tributaria para garantizar el cumplimiento y optimización contable.",
    image: Tributaria,
    alt: "Asesoría Tributaria",
  },
  
 
]
